export default {
  secureStorageError: "Secure storage could not be initialized. Please retry before signing in.",
  secureStorageRetry: "Retry",
  // sign in/up
  email: "Email",
  username: "Username",
  password: "Password",
  currPassword: "Current Password",
  newPassword: "New Password",
  verifyNewPassword: "Verify New Password",
  changePassword: "Change Password",
  signIn: "Sign In",
  logout: "Sign Out",
  apiNotExists: "API does not exist",

  // calendar
  clear: 'Clear',

  // home
  welcomeMorning: "Good morning!",
  welcomeAfternoon: "Good afternoon!",
  welcomeEvening: "Good evening!",
  alLeft: "Remaining",
  al: "Annual Leave",
  leaveUnit: "{{leaveUnit}}",
  noAnnouncements: "No announcements to show.",

  // leaves
  leaveRecords: "Leave Records",
  noLeaveSelected: "No Leave Selected",
  noEmployeeSelected: "No Employee Selected",
  plsSelectLeave: "Click a row to view details.",
  search: "Search",
  ls: "Status",
  lAppr: "Approver(s)",
  lAttach: "Attachment(s)",
  approverComments: "Approver Comments",
  noLeaves: "There are no leaves currently - Full Team Available",
  weekLeaves: "Leaves for the current week",
  weekLeavesSub: 'Team members on leave right now',
  estimatedNote: "* Days are an estimation",

  // Reports 
  showrep: "Show Report",
  exportExcel: "Export To Excel",
  refFilter: "Refresh Filters",
  filter: "Filter",
  refFilterTool: "Press this button to refresh the filter base on your current filter selection. For example, if you selected a company or the filters related to your company will the refreshed and all other comanies will be hidden ",
  repGrps: "Report Groups",
  reps: "Reports",
  filters: "Report Filters",
  mandatoryError: "Please select mandatory fiters: ",

  // STAFF LEVELS
  levelName: "Level",
  order: "Order",
  interfaceCode: "Interface Code",
  interfaceDescription: "Interface Description",
  regionalCode: "Regional Code",
  staffSuccessSave: "Staff Level Successfully Saved",
  staffSuccessDelete: "Staff Level Successfully Deleted",
  failedDelete: "Failed to Delete",
  failedSave: "Failed to Save",
  invalidOrder: "Order must be numeric only",
  noStaffDataPreview: "No Data Available\nIt looks like there are no Staff Levels added yet. Please add new Staff Level to see them here.",

  // SENIORITY LEVELS
  HierarchyCode: "Hierarchy Code",
  order: "Order",
  person: "Person",
  isOvertimePayable: "Is Overtime Payable ?",
  isOvertimeAllowed: "Is Overtime Allowed ?",
  interfaceCode: "Interface Code",
  interfaceDescripiton: "Interface Descripiton",
  regionalCode: "Regional Code",
  noSeniorityLevel: "No Data Available\nIt looks like there are no Seniority Levels added yet. Please add new Seniority Levels to see them here.",
  requiredLevel: "Please Enter Level",
  requiredRegionalCode: " Please Enter Regional Code",
  requiredHierarchyCode: "Required Hierarchy Code",
  senioritySuccessSave: "Seniority Level Successfully Saved",
  senioritySuccessDelete: "Seniority Level Successfully Deleted",
  cannotDeleteInUse: "Cannot Delete, Seniority Level is In Use",
  invalidPerson: "Person must be numeric only",
  rowDeletedLocally: "Row Deleted Locally",
  invalidItem: "Invalid Item",
  duplicateHierarchyCodeMessage: "Duplicate hierarchy codes detected. Please check and correct duplicates.",

  // Company Job Titles  
  jobTitleCode: "Job Title Code",
  abbreviation: "Abbreviation",
  regionalCode: "Regional Code",
  alternativeDescription: "Alternative Description",
  alternativeAbbreviation: "Alternative Abbreviation",
  d365Code: "D365 Code",
  successSave: "Job Title Successfully Saved",
  successDelete: "Job Title successfully deleted",
  sortDesc: "Sort Job Title Code A-Z",
  sortAsc: "Sort Job Title Code Z-A",
  requiredJTC: "Job Title Code is required.",
  Errorloadingjobtitles: "Error loading job titles",


  // Leave Types Company 
  code: "Code",
  cumulative: "Cumulative with other Leave Type",
  showOnScheduler: "Show on Scheduler",
  laRequired: "LA Required",
  createLeaveScheme: "Create Leave Scheme",
  ignoreLeaveSchemeRules: "Ignore Leave Scheme Rules",
  ignoreSaturdays: "Leave allowance to ignore Saturdays",
  ignoreSundays: "Leave allowance to ignore Sundays",
  ignorePublicHolidays: "Leave allowance to ignore Public Holidays",
  ignoreWellbeingDays: "Leave allowance to ignore Wellbeing Days",
  canCF: "Enable Leave Allowance Carry Forward",
  publicHoliday: "Public Holiday",
  wellbeingDay: "Wellbeing Day",
  allowAttachment: "Allow Leave to have attachment",
  requireAttachment: "Attachment is required",
  allowNegativeBalance: "Allow Neg. Balance",
  calendarDays: "Calendar Days",
  setMonthsNotification: "Set Months Notification",
  attachmentRequiredAfterUnits: "Attachment required when leave allowance is greater than",
  customAllowance: "Custom Allowance",
  changeOfRule: "Change of rule",
  restrictWithinPeriod: "Restrict within period",
  cfExpiry: "c/f Expiry",
  balanceExceededMsg: "Balance Exceeded Msg",
  submittedMessage: "Sumbitted Message",
  daysBefore: "Days Before",
  recreateLeavesForCurrentYear: 'Recreate Leaves for Current Year',

  // new request
  teamOnLeave: "Team members on leave during the same period:",
  TM: "* Other team members are on leave during the same period",
  LT: "Leave Type",
  LD: "Leave Dates",
  LDs: "Leave Details",
  LRDs: "Leave Record Details",
  LL: "Leave Lines",
  NOLAA: "No Pending Leaves to Approve",
  selectDate: "Select Dates",
  selectDateTitle: "Select dates for the duration of the Assessment",
  selectItem: "-- Select --",
  selectYear: "Select Year",
  Dur: "Duration",
  Rep: "Replacement",
  Comm: "Comments",
  anyComm: "Any Comments?",
  attach: "Attachments",
  selectAttach: "No Attachments",
  open: "Open",
  remove: "Remove",
  view: 'View',
  cancel: "Cancel",
  okay: "Okay",
  submit: "SUBMIT",
  edit: "Edit",
  NLE: "Request Leave on behalf of",
  employee: "Employee",
  // errors
  errDur0: "Duration cannot be equal to 0",
  errDur: "Invalid Duration",
  errFile: "File is too large",
  errCalendar: "Please select date(s)",
  errApprover:
    "There is an error with your approvers. Please contact your HR administrator to resolve. The Leave is now saved please use the My Leaves to submit once the error is resolved.",
  errReqFieldsNotFilled: "Please fill in the missing required fields and try again!",
  errNonUniqueValues: 'Another record exists with the current value(s). Update accordingly and try again.',
  // success
  succLA: "Leave Application was successfully submitted",
  TEAM: "My Team",
  succDocs: "Document Submission was successful",
  // HR Admin 
  teacherPeriods: 'Teacher Periods',
  teacherPeriodsApproval: 'Approvals',
  teacherPeriodsSucc: 'Teacher Periods was successfully saved',
  teacherPeriodsfail: 'Teacher Periods failed to save',

  emptyleave: 'No Leave Analysis.\nPlease contact your HR Administrator',

  // LoadingLeaves
  LoadingLeaves: 'Refreshing Leave Application List',

  // upcoming
  thisWeek: "This Week",
  startsOn: "Starts on",
  noUpcoming: "There are no upcoming leaves for this week",

  // Toggle
  toggleShow: 'Show Approved',
  togglePending: 'Show Pending',

  // balances
  available: "Available",
  used: "Used",
  remaining: "Remaining",
  show: "Show Details",
  hide: "Hide Details",
  BroughtFoward: "Brought Forward",
  BroughtFowardExpired: "Brought Forward Expired",
  CurrAllowance: "Current Allowance",
  CurrAllowanceEOY: "ALs until the end of the year",
  LeaveTaken: "Leave Taken",
  YearlyAllowance: "Yearly Allowance",

  // team schedule
  noLeavesOnSelectedDate: "There are no leaves on the selected date",
  selectDateRange: "Select Dates",

  // pending tasks
  pendingTasks: "Pending Tasks",
  pendingTasksSub: 'Actions required from you',
  noPending: "There are no pending tasks",

  oof: "OUT OF OFFICE",

  // personal information
  marital: "Marital Status",
  single: "Single",
  married: "Married",
  engaged: "Engaged",
  divorced: "Divorced",
  widow: "Widow(er)",
  children: "Νο. of Children",
  address: "Address",
  town: "Town",
  country: "Country",
  postcode: "Postcode",
  postcodePlaceholder: "Postcode",
  personalMobile: "Personal Mobile",
  personalEmail: "Personal Email",
  save: " Save ",
  noResultsFound: "No results found",
  currentCity: 'Current City',
  currenctCountry: 'Current Country',
  currentAddress: 'Current Address',

  // emergency information
  emergCont: "EMERGENCY CONTACT DETAILS",
  relationship: "Relationship",
  spouse: "Spouse",
  father: "Father",
  mother: "Mother",
  child: "Child",
  other: "Other",
  fullName: "Full Name",
  telephone: "Telephone",
  mobile: "Mobile",
  emergDoc: "DOCTOR DETAILS",
  emergContactDetails: 'Emergency Contact Details',
  // errors
  errTown: "Invalid Town",
  errCountry: "Invalid Country",
  errMobile: "Invalid Number",
  errEmail: "Invalid Email",
  errName: "Invalid Name",

  // documents
  noDocuments: "No documents have been uploaded yet!",
  documentFunctionality: "Edit / Delete",
  location: "Location",
  department: "Department",
  seniorityLevel: "Seniority Level",
  jobTitle: "Job Title",
  company: "Company",
  chooseDocument: "Choose Document",
  downloadDocument: "Download",
  chooseAllEmployees: "Choose All Employees",
  findEmployees: "Find Employees",
  removeAllEmployees: "Remove All Employees",
  chooseAnEmplMessage: "Please choose at least one Employee.",
  chooseACompanyMessage: "Please choose a Company first.",
  chooseADocMessage: "Please choose a Document.",
  findEmplMessage: 'Please press on "Find Employees" first.',
  deleteDocMessage: 'Are you sure you want to delete the document? This action cannot be undone.',
  yesButton: 'Yes',
  noButton: 'No',


  //LeaveSchemes
  Rules: 'Rule',
  Parameters: 'Parameters',
  Types: 'Leave Types',
  params: 'Parameters',
  leaveUnitNumber: 'Number of Leave Units',
  workunits: 'Work Units/Week',
  boundary: 'Boundary',
  pro_rata: 'Pro Rata',
  criteria: 'Criteria',
  addcriteria: "Additional Criteria",
  appliedcriteria: "Applied Filtering Criteria",
  value: "Parameter Value",
  shortleavemax: "Short Leave Max",
  shortleavetotal: "Short Leave Total",
  totalleavemax: "Total Leave Max",
  maxcf: "Max Carried Forward",
  twice: "Included Twice",
  notIncluded: "Not Included",
  existingschemes: 'Leave Schemes Of Selected Leave Type',
  textdescr: 'Criteria',


  //Mass Upload
  downloadAsExcel: 'Export to Excel',
  viewExcel: 'Open Excel File',
  importExcel: 'Upload Excel File',
  noDataFound: 'No Data Available',
  incompatibleData: 'The provided data do not match the selected destination.\nPlease update either the destination or the data to continue.',
  dataDestinationUpload: 'Select the Destination for your Data Upload',
  succImportedExcel: 'Your data has been successfully imported!\n Amount of Data Imported',
  unsuccImportedExcel: 'We encountered an issue while importing your data. Please try again later. If the problem persists, contact our support team for assistance.',
  unsavedChangesMassUploadMessage: 'You have unsaved changes.\n If you go back now, your changes will be lost.\n Please save your changes before proceeding.',
  maxLength: 'Max Length',
  noMaxLength: 'No Max Length',
  columnName: 'Column Name',
  dataType: 'Data type',
  add: 'Add',
  remove: 'Remove',
  destinationTableMess: 'Have you selected the correct destination table for your data?\nPlease verify to ensure accurate data insertion.',
  hold: 'Uploading...\nPlease wait.',

  // custom phone number
  phoneNumber: "Number",

  // general responses/errors
  errRequired: "*Required",
  errSelectTypeBeforeDate: "Please select type of leave before selecting dates",
  errAllFields: "Please fill in all required fields",
  detailsSaved: "Details have been saved",
  errLoadingData: 'There was an error while loading data.',

  // password errors
  errMismatch: "Your password and confirmation password do not match",

  // settings
  languageSelector: "Language",

  // LAA
  approve: "APPROVE",
  reject: "REJECT",
  TeamMembersOnLeave: "Overlapping Approved Leaves",
  currentRemainder: "Current Remainder",
  pendingApprovals: "Pending Leave Approvals",

  leaveApprovalAccepted: "Leave Approval Successfully Accepted",
  leaveApprovalRejected: "Leave Approval Successfully Rejected",
  leaveApprovalUnsubmitted: "Leave Approval Successfully Unsubmitted",
  leaveApprovalAcceptedFailed: "Leave Approval Failed",
  leaveApprovalRejectedFailed: "Leave Rejection Failed",
  leaveApprovalUnsubmittedFailed: "Leave Unsubmission Failed",

  asc: "OLDEST TO NEWEST",
  dsc: "NEWEST TO OLDEST",

  approved: "Approved",
  approveAll: "Approve All",
  submitted: "Submitted Pending Approval",

  AllLeaves: "ALL LEAVES",
  SubmittedLeaves: "SUBMITTED LEAVES",
  ApprovedLeaves: "APPROVED LEAVES",
  UnsubmittedLeaves: "UN-SUBMITTED LEAVES",
  RejectedLeaves: "REJECTED LEAVES",

  // CURRENTLY NOT USED
  slLeft: "Sick Leave Left",
  unsubmit: "Unsubmit",

  true: "True",
  false: "False",

  // Surveys
  survey: "My Surveys",
  surveyAdmin: "Survey Admin",
  newAssm: "New Assessment",
  addQuestion: "Question",
  addSection: "Section",
  requiredQuestion: "Required Question",
  questionTypeSelect: "Type",
  importSurvey: "Import",
  saveSurvey: "Save   ",
  surveyResponse: "Respond to survey",
  surveyEdit: "Edit survey",
  surveyResults: "Survey Results",
  updateSurvey: "Update",
  requireLogedInUser: "Require Logged In User",
  surveyname: "Name",
  surveyinstructions: "Instructions",
  surveyAdminFunction: "Admin Functionality",
  surveycompletedon: "Completed On",
  surveycomplete: "Complete",
  resultsPerCandidate: "All submitted survey results",
  surveyAnalytics: "Survey Analytics",
  analytics: "Analytics",
  Agree: "Agree",
  stronglyAgree: "Strongly Agree",
  neutral: "Neutral",
  Disagree: "Disagree",
  stronglyDisagree: "Strongly Disagree",
  allowedMultiple: "Allowed Multiple Selection",
  text: "Text Answers",
  Rating5: "5 Start Rating",
  Rating10: "10 Star Rating",
  trueFalseOptions: "True / False Options",
  ratingOptions: "Agree / Disagree Options",
  options: "Options",
  surveyCreate: "Create Survey",
  addAgreeDisagreeOption: "Add Subquestion Option",

  // Assessments
  assessment: "My Assessments",
  assmEmplPreview: 'Employee Assessement preview',
  assmEmplPreview: 'Employee Assessement preview',
  assessmentsAdmin: "Assessments Admin",
  assessmentcomplete: "Completed",
  assessmentpending: "Pending",
  AssessmentTitle: "Assessment Title",
  sectiontitle: "Section Title",
  questionTitle: "Question Title",
  assmTableOfContents: "Table Of Contents",
  assmWeight: "Weight Totals",
  assessmentclosed: "Closed",
  assessmentname: "Name",
  assessmenttype: "Type",
  assessmentstatus: "Assessment Completion Rate per Stage",
  status: "Status",
  assessmentsubmited: "Submitted",
  assessmentstage: "Stage",
  assessmentsactive: "Active",
  assessmentedit: " Assessment Edit",
  assessmentdelete: "Delete",
  assessmentresult: "Assessment Results",
  assessmentResponse: "Assessment Response",
  assessmentcreate: "Create Assessment",
  assmallowflag: "Allow The Change Of The Appraiser",
  assmselectworkflow: "Select WorkFlow",
  loadingselectedassm: "Loading Selected Assessment...",
  assmselectcompany: "Select Company",
  assmselectgroup: "Select Group",
  assmfunctionality: "Admin Functionality",
  analytics: "Analytics",
  group: "Group",
  groupcreate: "Create Group",
  grouptitle: "Group Title",
  lockgroup: "Lock Group",
  groupedit: "Edit Group",
  updategroup: "Update Group",
  quantitative: "Quantitative",
  hidemeetingcomparison: "Hide Meeting Comparison",
  isSectionCover: 'Convert Section to Cover',
  graphAxis: 'Graph Axis',
  useOnGraph: 'Use On Result Graph',
  isQuestCover: 'Convert Question to Cover',
  showresults: "Show in Consolidated Results",
  ROTW: "Read Only To Whom",
  addQuestionLine: "Line",
  addTccQuestionLine: "Additional Response",
  weight: "Weight (in %)",
  totalSectionQuestions: "All the question weights in current section must add up to 100%. Current total: ",
  totalSection: "All the section weights must add up to 100%. Current total: ",
  weightMessage: "Please note that all weights must add app to 100%",
  debug: "Debug",
  progress: "Progress",
  Essay: "Essay",
  TableCustomControls: "Table Custom Controls",
  Scale: "Scale",
  ScaleNa: "Scale with N/a",
  Boxes: "Agree/Disagree Boxes",
  requiredQuestionLine: "Required Question Line",
  required: "Required",
  cancelmessage: "Are you sure you want to cancel the creation of this Assessment?",
  appraisee: "Appraisee",
  sendReminder: "Reminders",
  previewAppraisee: "Preview Appraisee",
  previewAppraiser: "Preview Appraiser",
  stage: "Stage - ",
  appraiser: "Appraiser",
  participations: "Participations",
  appraiseename: "Appraisee Name",
  appraiseeid: "AppraiseeID",
  appraisername: "Appraiser Name",
  appraiserid: "AppraiserID",
  allLeaves: "All leaves",
  allLeavesMinor: "All Leaves This Year",
  submitted: "Submitτed",
  submittedMinor: "Pending Approval",
  approved: "Approved",
  approvedMinor: "This Year",
  rejected: "Rejected",
  rejectedMinor: "This Year",
  unsub: "Unsubmitted",
  unsubMinor: "Draft",
  activesubmitted: "Active / Submitted",
  partfunctionality: "Functionalities",
  showsubmitted: "Show Submitted",
  showunsubmitted: "Show Unsubmitted",
  goback: "Back Done",
  goforward: "Done",
  partmessage: "The current Assessment is going to be saved before moving forward.",
  updateassm: " Update",
  addparticipations: "Add Participant",
  editparticipations: "Edit Participant",
  deleteGroupConfirmation: "Are you sure you want to delete this Group?",
  deleteAssmConfirmation: "Are you sure you want to delete this Assessment?",
  areusure: "Are you sure?",
  cancelCreationMsg: "The creation of this assessment is going to be canceled",
  cancelEditMsg: "The changes on this assessment are going to be canceled",
  importAssm: 'Import Assessment',
  importPart: 'Import Participants',
  addPart: " Add Participants",
  exportRawData: "Export Raw Data",
  performanceReview: "Performance Review",
  hideCompletionRate: "Hide Completion Rate",
  hideExtraData: "Hide Extra Data",
  showCompletionRate: "Show Completion Rate",
  showExtraData: "Show Extra Data",
  selectQuestionType: "-- Please select Question Type --",
  nothingToPreview: "No Results to Preview",
  noEmplAuth: "You are not authorized to view any employees. Please contact your HR Administrator.",
  dragQuestion: "Please drag the question under the correct column.",
  notSaved: "Assessment could not be saved. Please contact your administrator",
  only1GraphSection: 'You must define two sections for the Graph to be created.',
  graphX: 'Please define only 1 X Axis',
  graphY: 'Please define only 1 Y Axis',
  responsePlaceholder: 'Please enter your response',
  loadingMoreAssm: "Loading More Assessments....",
  saveGroupFailMsg: "Group failed to save: ",
  saveAssmFailMsg: "Assessment failed to save!",
  weightTotalError: "All weights must be totaling 100%",
  assmTitleError: "Please enter Assessment title",
  assmDateError: "Please enter valid Assessment Dates",
  assmWorkflowError: "Please enter Assessment Workflow",
  assmCompanyError: "Please enter Assessment Company",
  assmGroupError: "Please enter Assessment Group",
  assmQuestTitleError: "Please enter Titles to all Questions",
  assmQuestTypeError: "Please enter Question Type to all Questions",
  assmQuestLineTypeError: "Please enter Question Type to all Question Lines of TCC",
  saveGroupErr: "Group failed to save",
  questRequired: 'Please enter response to all Required Questions',

  // Company
  addCompanyLogo: 'Add Logo',
  loadingselectedCompany: 'Loading Selected Company...',
  companyCode: 'Company Code',
  companyLogo: 'Company Logo',
  companyLogoSub: 'Upload your company logo or branding image',
  companyName: 'Company Name',
  companyAnotherName: 'Alternative Name',
  companyLegalName: 'Legal Name',
  companyCurrency: 'Currency',
  companyActve: 'Active',
  compSaveSucc: 'Company Saved Successfuly',
  compSaveFail: 'Company Failed to Save',
  selectedCompany: 'Selected Company',
  searchResults: 'Search results for: ',
  selectCompany: 'Select Company before searching for employees.',

  // Salary 
  salarySchemeDesc: "Salary Scheme Description",
  schemeRange: "Salary Scheme Date Range",
  salaryComponentDesc: "Salary Component Description",
  order: "Order",
  evaluation: "Evaluation",
  formula: "Formula",

  // Timesheets 
  timesheet: 'Timesheet',
  timesheetName: 'Timesheet Name',
  approver: 'Approver',
  submitted: 'Submitted',
  year: 'Year',
  week: 'Week',
  newline: 'New',
  showComments: 'Comments',
  nameEmpty: 'Timesheet name cannot be empty ',
  approverEmpty: 'Please select an approver',
  branchEmpty: 'Please select a branch',
  locationEmpty: 'Please select a Location',
  newEmpl: 'New Employee',
  addAll: 'Add All Employees',
  missingptsdh: 'Please select period time',
  defNum: 'Enter default number of periods to apply to all added employees for all months. Please note that all current entries will be deleted',
  average: 'Year Average',
  averageAdditional: 'Additional',
  unitConvert: 'Units',
  addUnit: 'Additional Units',
  selectSchoolYearEndDate: 'Please select school year end date for this employee.',
  confirmSelection: 'Confirm Selection',
  pickAnItem: 'Pick items',
  oneItemSelected: 'One Item Selected',
  tsErrorSaving: 'Saving the timesheet failed.',
  delete: 'Delete',
  saveAll: 'Save Timesheet',
  approvedSuccess: 'Timesheet has been approved.',
  rejectSuccess: 'Timesheet has been rejected.',
  errorSubmit: 'There was an error with submitting the timesheet.',
  rejCom: 'Rejection Comments',
  wayOfOvertime: "Select way of overtime payment",
  sum: 'SUM',
  total: "Total",
  standardUnits: "Standard Units",
  overtime: "Overtime",
  payableOvertime: "Payable Overtime",
  chargableU: 'Chargeable Units',
  nonchargableU: 'Non-Chargeable Units',
  payableOvertimeU: 'Payable Overtime Units',
  expenseTotal: 'Expense Total (€)',
  viewTSDetails: "View Timesheet Details",
  nopreviousTS: "No previous timesheets",
  nopendingTS: "No pending timesheets",
  pendingApprovalsTS: "Pending Approvals",
  showperiodB: "Show Period B",
  showperiodA: "Show Period A",
  chargable: 'Chargable',
  nonChargable: 'Non Chargable',
  dateOutOfRange: 'Selected date is outside the current timesheet period.',
  noEmployees: 'No Employees found',
  succCreatingAll: "Timesheets created successfully for all employees",
  errCreatingAll: "Error creating timesheets",
  noSubmit: "No timesheets to submit",
  noAllSubmitSucc: "Some timesheets didn't submit successfully",
  TSleavesHolidays: 'Leaves & Holidays',
  exceedsMaxHours: "Hours on some day/s exceed maximum allowed.",
  incompleteDays: "Some days are not fully completed. Please check and complete all required hours.",
  etypenotFound: "No Employment type found",

  //Clients
  createNewClient: 'Create New Client',
  clientName: 'Client Name',
  clientCode: 'Client Code',
  editClient: 'Edit Client',
  update: 'Update',
  deleteClientConfirmation: 'Are you sure you want to delete this Client?',
  pleaseFillAllFields: 'Please fill in all fields to save.',
  deleteSuccess: 'Client deleted succesfully',
  clientUpdatedSuccessfully: 'Client updated succesfully',
  clientCreatedSuccessfully: 'Client created succesfully',
  createNewProject: 'Create New Project',
  editProject: 'Edit Project',
  noprojects: 'No Projects for this client.',
  partnerName: 'Partner Name',
  managerName: 'Manager Name',
  phasecode: 'Phase Code',
  isPayable: 'Payable',
  projUpdatedSuccessfully: 'Project updated succesfully',
  projectCreatedSuccessfully: 'Projecct created succesfully',
  deleteProjectConfirmation: 'Are you sure you want to delete this Project?',
  codeMaxLengthWarning: 'Code should be max 7 characters.',
  formReset: 'Reset Form',
  deleteSuccessP: 'Project deleted succesfully',
  insertError: 'There was an error on inserting. Please check that the code is unique .',
  descriptionRequired: "Description is required.",
  jobNoRequired: "Job Number is required",
  phaseCodeRequired: "Phase Code is required",
  printTSSuccess: 'The timesheet was printed succesfully.',
  printTimesheet: 'Print Timesheet',

  //Timesheet Expenses
  entity: 'Entity',
  jobName: 'Job Name',
  date: 'Date',
  expense: 'Expense',
  unitRate: 'Unit Rate',
  measureUnit: 'Measure Unit',
  units: 'Units',
  attachmentsList: 'Attachments List',
  noAttachments: 'No Attachmens Uploaded',
  uploadDocuments: 'UploadDocuments',
  doeRequired: "Date of Expense is required.",
  expCodeRequired: "Expense Code is required",

  //Timescheme
  month: 'Month',
  timescheme: 'Time Scheme',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  hasEmptyTimeschemesError: 'All Time Schemes must be filled in.',
  timeschemesSavedSuccMess: 'Time Schemes saved successfully!',
  timeschemesErr: 'An error occurred while saving the time schemes. Please try again later.',

  // Copy Timesheet
  copyTSSuccess: 'Timesheet copied successfully.',
  errorcopy: 'There was an error with copying the timesheet.',
  copyTimesheet: 'Copy Timesheet',
  fromTimesheet: 'From Timesheet',
  toTimesheet: 'To Timesheet',
  copy: 'Copy',
  deleteAllLinesBeforeCopy: 'Need to delete all existing lines before copying timesheet.',
  copyLines: 'Copy Timesheet Lines',
  deleteTSMsg: 'Delete timesheet and all timesheet lines entered.',

  // Branches
  branch: "Branch",
  regCode: "Regional Code",
  d365Code: "D365 Code",
  new: 'New',
  deleteBranch: 'Delete',
  saveChanges: 'Save',

  //Documents
  nouserswerefound: 'No Users Were Found',

  //* Employees
  // Select Employee
  loadingEmployees: 'Loading Employees...',
  reset: 'Reset',
  apply: 'Apply',
  noSelectedCompanyPleaseSelect: 'No selected company. Please select a company from the Company tab first!',
  changeBranchesMessage: 'You have unsaved changes.\n If you switch now, your changes will be lost.\n Please save your changes before proceeding.',
  branchesLoadingPreview: 'No data available\nIt looks like there are no branches added yet. Please add new branches to see them here.',
  branches: 'Branches',
  salarySchemeLoadingPreview: 'No data available\nIt looks like there are no Salary Schemes added yet. Please add new Salary Schemes to see them here.',
  familyDetailsLoadingPreview: 'No data available\nIt looks like there are no Family Details added yet. Please add new Family Details to see them here.',
  promHistLoadingPreview: 'No data available\nIt looks like there are no Promotion History Details added yet. Please add new Promotion Details to see them here.',
  upload: 'Upload Photo',

  // Salary 
  salarySchemeDesc: "Salary Scheme Description",
  startDate: "Start Date",
  endDate: "End Date",
  absenceType: "Absence Type",
  noAbsenceData: "No Absence Analysis",
  noLeaveAnalysisData: "No Leave Analysis Data",
  leaveBalance: "Leave Balances",
  NOFY: "No fiscal years found for the selected employee",


  // ******* Edit Employee ********

  //Salary Reviews

  reviewDescription: "Review Description",
  schemeDescription: "Scheme Description",
  startDate: "Start Date",
  endDate: "End Date",
  comments: "Comments",
  currency: "Currency",
  annualGrossSalary: "Annual Gross Salary",
  monthlyGrossSalary: "Monthly Gross Salary",
  changeSchemeMessage: "By changing the salary scheme, the values will be deleted because it has different components.",
  noReviewDataPreview: "No Data Available\nIt looks like there are no Reviews added yet. Please add new Review to see them here.",
  salarySchemeMustBeSelected: "Salary Scheme Must Be Selected",
  reviewSavedSuccessfully: "Review Saved Successfully",
  errorSavingReview: "Error Saving Review",
  endDateMustBeSelected: "End Date Must Be Selected",
  reviewMarkedForDeletion: "Review Marked For Deletion",
  nosalarycomponentsavailable: 'No Salary Components Available',

  //Salary Modal
  enterComments: "Enter Comments",
  editSalaryReview: "Component",
  salaryComponent: "Salary Component",
  current: " Current Review",
  previous: " Previous Review",
  difference: "Difference",
  percentageDifference: "Difference (%)",



  // PERSONAL Tab
  personal: "Personal",
  personalDetails: "Personal Details",
  fullName: 'Full Name',
  name: 'Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  sex: 'Gender',
  foreignEmplId: 'Foreign Employee Id',
  telmob2: 'Secondary Mobile Phone',
  workmob2: 'Work Mobile',
  hcode: 'Seniority',
  holdate: 'Prof. Experience Start Date',
  isUnionM: 'Is Union',
  parkLot: 'Parking Lot',
  parkingCardHolder: 'Has parking card?',
  car: 'Has Car?',
  nextOfKinOne: 'Next of Kin:',
  nokAddressOne: 'Next of Kin Address',
  nokTelMobOne: 'Next of Kin Mobile',
  nokTelOne: 'Next of Kin Phone',
  nokRelOne: 'Next of kin Relationship',
  emergencyContactDetails: 'Emergency Contact',
  nextofkin: 'Name:',
  nokaddress: 'Address',
  noktelmob: 'Phone Number',
  noktel: 'Next of Kin Phone',
  nokRel: 'Relationship',
  nameGR: 'Name (other language)',
  drname: 'Doctor Name',
  dradress: 'Doctor Address',
  drtel: 'Doctor Telephone',
  drtelmob: 'Doctor Mobile',
  companySecondary: 'Secondary Company',
  locationSecondary: 'Secondary Location',
  title: 'Title',
  employeeID: 'ID',
  arcNumber: 'ARC Number',
  foreignId: 'Foreign ID',
  telhome: 'Residence Telephone',
  siNo: 'Social Insurance No.',
  taxID: 'Tax ID',
  opmNameNickname: 'OPM Name/Nickname',
  gender: 'Gender',
  initials: 'Initials',
  nationality: 'Nationality',
  scndNationality: 'Second Nationality',
  passportNo: 'Passport No.',
  passportIssDate: 'Passport Iss. Date',
  passportExpDate: 'Passport Exp. Date',
  dateOfBirth: 'Date of Birth',
  nameDay: 'Name Day',
  contactDetails: 'Contact Details',
  currentAddress: 'Current Address',
  currentCity: 'Current City',
  currentCountry: 'Current Country',
  area: 'Area Address',
  areacode: 'Area Code',
  bankAreaCode: 'Bank Area Code',
  workMobile: 'Work Mobile',
  residenceTel: 'Residence Tel.',
  personalFax: 'Personal Fax',
  extLine1: 'Ext. Line 1',
  extLine2: 'Ext. Line 2',
  intercom: 'Intercom',
  lockerNo: 'Locker Number',
  officeNo: 'Office Number',
  workEmail: 'Work Email',
  homeAddress: 'Home Address',
  homeCity: 'Home City',
  homeCountry: 'Home Country',
  familyDetails: 'Family Details',
  family: 'Family',
  maritalStatus: 'Marital Status',
  noOfChildren: 'Number of Children',
  ageGroup: 'Age Group',
  age: 'Age',
  nationalityGroup: 'Nationality Group',
  relType: 'Relation Type',
  relTypeReqMess: 'Relation Type is required!',
  nameReqMess: 'Name is required!',
  dotBeforeDoa: 'End Date must be later than the Date of Appointment!',
  doaReqMess: 'Date of Appointment is required!',
  deptReqMess: 'Department is required!',
  calcRevAllowanceMess: 'Calculating Revised Allowance...',
  calcRevAllowanceSuccMess: 'Calculated Revised Allowance!',
  startDateBeforeEndDateMess: 'Start Date must come BEFORE end date!',
  noEndDateMess: 'The user does not have an assigned end date.',
  nameAlphabetOnlyMess: 'Name can only contain alphabet characters!',
  occupation: 'Occupation',
  underSponsorship: 'Under Sponsorship',
  doNameday: 'Nameday',
  doIssuePassport: 'Passport Issue Date',
  familyDetailsTitle: 'Family Details',
  telmob: 'Mobile Number',
  educLevel: 'Education Level',

  // EMPLOYMENT Tab
  employmentType: 'Employment Type',
  placementDetails: 'Placement Details',
  paymentDetails: 'Payment Details',
  employmentDetails: 'Employment Details',
  employmentContext: 'Employment Context',
  buildingFloor: 'Floor',
  l4: 'L4',
  l5: 'L5',
  l6: 'L6',
  seniority: 'Seniority',
  paymentLevel: 'Payment Level',
  paymentSubLevel: 'Payment Sub-Level',
  jobDescription: 'Job Description',
  specialDuties: 'Special Duties',
  salaryEligibility: '13th Salary Eligibility',
  ministryOfEdu: 'Ministry of Education',
  subject: 'Subject',
  staffLevel: 'Staff Level',
  jobTitles: 'Job Titles',
  //Payment Details (Under Employment tab)
  bank: 'Bank',
  accountNo: 'Account Number',
  annualGrossSalaryGroup: 'Annual Gross Salary Group',
  paymentMethod: 'Payment Method',
  salarySpecifics: 'Salary Specifics',
  //Employment Details (Under Employment tab)
  actualStartDate: 'Actual Start Date',
  profExperienceStartDate: 'Professional Experience Start Date',
  expectedRetirementDate: 'Expected Retirement Date',
  dateMadePermanent: 'Date Made Permanent',
  probationPeriodMonths: 'Probation Period in Months',
  initialDeloitteStartDate: 'Current Contract End Date',
  transferDate: 'Transfer Date',
  active: 'Active',
  resigned: 'Resigned',
  notonprobation: 'Permanent',
  submitsTimesheets: 'Submits Timesheets',
  hasSignedConfLetter: 'Has Signed Confidentiality Letter',
  employeeNumber: 'Employee Number',
  timeCardNo: 'Time Card Number',
  jdeNum: 'JDE Employee Number',
  timescheme: 'Time Scheme',
  emplType: 'Employment Type',
  timetable: 'Timetable',
  yearsOfServGroup: 'Years of Service Group',
  dateOfAppointment: 'Date of Appointment',
  primary: 'Primary',
  allocation: 'Allocation %',
  emplDeptsTitle: 'Departments',
  salaryEligibilityTitle: '13th Salary Eligibility',
  servLine: 'Service Line',
  function: 'Function',

  reconciliationBalancesTitle: 'Leave Balances Reconciliation',
  reconcileBalances: 'Reconcile Balances',
  reconciliationMess: 'Reconciling...',
  reconciliationSuccMess: 'Reconciled Successfully!',

  schedule: 'Schedule',
  scheduleTitle: 'Schedule',
  noShiftSchedules: 'No Data Available\nIt looks like there are no Shift schedules added yet. Please add a new Shift schedule to see them here.',
  scheduleLoadingPreview: 'No Data Available\n\nIt looks like there is no Schedule added yet. Please add your Schedule to see it here.',
  emplDeptsLoadingPreview: 'No Data Available\n\nIt looks like there is no Departments added yet. Please add your Departments to see them here.',
  provFundLoadingPreview: 'No Data Available\n\nIt looks like there is no Provident Fund added yet. Please add your Provident Fund Details to see them here.',
  medicalSchemeLoadingPreview: 'No Data Available\n\nIt looks like there is no Medical Scheme added yet. Please add your Medical Scheme Details to see them here.',


  leavebf: 'Leaves Brought Forward',
  leavebfExpired: 'Leaves Brought Forward Expired',
  allowance: 'Allowance',
  taken: 'Taken',
  paidLost: 'Paid/Lost',
  accLeaveBalances: 'Accumulated Leave Balances',
  recBalances: 'Reconcile Balances as Of',
  startDateEmployment: 'Start Date of Employment',
  dateOfTermination: 'Date of Termination',
  dateOf13thSalaryEligibility: 'Date of 13th Salary Eligibility',
  calcRevisedAllowance: 'Calculate Revised Allowance',
  revisedAllowance: 'Revised Allowance',
  difference: 'Difference',
  other: 'Other',
  reconcileBalances: 'Reconcile Balances',
  activities: 'Activities',
  personalInterests: 'Personal Hobbies & Interests',
  residencePermitNumber: 'Residence Permit Number',
  residencePermitExpiry: 'Residence Permit Expiry',
  probPeriodinMonths: 'Probation Period in Months',
  dmPermnt: 'Date Made Permanent',
  doExpRetirmnt: 'Date of Expected Retirement',
  // MISCELLANEOUS Tab
  miscellaneousTitle: 'Miscellaneous',
  memberOfUnion: 'Member of Union',
  union: 'Union Name',
  memberOfProvFund: 'Member of Provident Fund',
  memberOfMedicalScheme: 'Member of Medical Scheme',
  provFund: 'Provident Fund',
  medScheme: 'Medical Scheme',
  // Car Park Details
  carParkDetail: 'Car Park Detail',
  parking: 'Parking',
  parkingLotNo: 'Parking Lot Number',
  isCarParkCardHolder: 'Is Car Park Card Holder',
  parksAtSpecifiedParking: 'Parks Daily at Specified Parking Lot',
  vehRegNo: 'Vehicle Register Number',
  //Medical
  medicalDetailsTitle: 'Medical Details',
  medicalConditions: 'Medical Conditions',
  bloodType: 'Blood Type',
  doctor: 'Doctor',
  unionsTitle: 'Unions, Medical Scheme and Provident Fund',

  //Timesheets
  MyTimesheets: 'My Timesheets',
  nextTimesheet: 'Next Timesheet',
  period: 'Period',
  showSubmitted: 'Show Submitted',
  showApproved: 'Show Approved',
  TSfilters: 'Filters',
  waitingApproval: 'Waiting For Approval',
  timesheetDetails: 'Timesheet Details',
  TSchargable: 'Chargeable Time',
  TSnonchargable: 'Non-Chargeable Time',
  TSOutOfPocket: 'My Out Of Pocket Expenses',
  TSinfo: 'Timesheet Information',
  noLinesToShow: 'There are no lines to show for this Timesheet.',
  jobName: 'Job Name',
  jobCode: 'Job Code',
  phaseCode: 'Phase Code',
  jobtitle: 'Job Title',
  newTimesheet: 'New Timesheet',
  select: 'Select',
  timesheetSelection: 'Timesheet Selection',
  errorPhoto: 'Error loading employee photos',

  // Trainings
  noTrainings: "There are no trainings currently.",
  titleAsc: "Title Ascending",
  titleDesc: "Title Descending",
  dateAsc: "Date Ascending",
  dateDesc: "Date Descending",
  all: "All",
  category: 'Category',
  trainingLocation: 'Training Location',
  trainingProvider: 'Training Provider',
  externalFacilitator: 'External Facilitator',
  ldNeed: 'Learning and Development Need',
  ldMethod: 'Learning and Development Method',
  isCompleted: 'Completed',
  days: 'Days',
  hrs: 'Hours',
  workhrs: 'Work Hours',
  fees: 'Fees',
  subsidy: 'Subsidy',
  othercosts: 'Other Costs',
  costperempl: 'Avg.Cost/Participant',
  equalCost: 'Equal Cost/Participant',
  isabroad: 'Abroad',
  openseminar: 'Open-Seminar',
  isinternal: 'Internal Training',
  iseLearning: 'e-Learning',
  userEditable: 'Is User Editable',
  subsidyApplies: 'Subsidy Applies',
  subsidyProvider: 'Subsidy Provider',
  applicationDate: 'Apprication Date',
  receivedDate: 'Recieved Date',
  doCertExp: 'Expiry Date',
  certExpNotify: 'Notify Me',
  comment: 'Comment',
  saveFailed: "Failed to save data.",
  dateValidation: "End Date must be after Start Date.",
  titleReq: "Title is required.",
  startDateReq: "Start Date is required.",
  endDateReq: "End Date is required.",
  companyReq: "Company is required.",
  totalNumberOfParticipants: 'Total Numeber Of Participants',
  participants: 'Participants',
  isAccepted: 'Is Accepted',
  isFacilitator: 'Is Facilitator',
  firstEvaluation: 'First Evaluation',
  secondEvaluation: 'Second Evaluation',
  cost: 'Cost',
  training: 'Training',
  documentType: 'Document Type',
  fileName: 'File Name',
  code: 'Code',
  deleteAllPartConfirmation: 'Are you sure you want to delete all the participants of this training?',
  noFileAvailable: 'No file available for download.',
  failedDownload: 'Failed to prepare file for download.',
  dateTrnEmpty: 'Please select a date.',
  typeEmpty: 'Please enter a document or document type.',
  noParticipantsToDelete: 'No participnats to delete.',
  allParticipantsDeleted: 'All participants are deleted.',
  errorDeletingParticipants: 'Error deleting participants.',
  copyPartSuccess: 'Copy Participants successfuly.',
  copyPartError: 'There was an error when copying participants.',
  printTrnSuccess: 'Training report was printed successfuly.',
  noParticipantsToExport: 'There are no participants to export.',
  exportSuccess: 'Exporting participants was successful.',

  //Modules
  duration: 'Duration(hours)',
  participantsLeft: 'Participants Left',
  attendees: 'Attendees',
  facilitator: 'Facilitators',
  employeeEmpty: 'Please select Employee in each row',
  invalidDuration: 'Duration is invalid.',
  descEmpty: 'Please fill in the Description field',
  codeEmpty: 'Please fill in the Code field',
  NoDataPreview: 'No data to preview',
  trnEmpty: 'No training selected in all rows.',
  validationMssg: 'A training already has prerequisites.',
  validationErr: 'Failed to validate prerequisites.',
  dublicatedTRN: 'You have training(s) included more than once.',

  //MyTrainings
  filterAccepted: 'Filter Accepted',
  dateOfCompletion: 'Date Of Completion',
  accepted: 'Accepted',
  pendingAcceptance: 'Pending Acceptance',
  courseName: 'Course Name',
  newTraining: 'New Training',
  TRNDetails: 'Training Details',
  durationHrs: 'Duration (Hours)',
  acknowledgeCompletion: 'Aknowledge Completion',
  errorInsert: 'There was an error while trying to insert new data.',
  confirmCompletion: 'I have reviewed And understood the topic presented. After clicking the Acceptance Button, please sign the training participation form (at the HR Department) and note the date that you have completed the training.',

  //Events
  event: 'Event',
  addOrg: 'Add Organizer',
  restrictRegistration: 'Restrict Registration',
  confirmParticipantsAutomatically: 'Confirm Participants Automatically',
  limitOnePersonPerParticipant: 'Limit One Session Per Participant',
  createEvent: 'Create Training Event',
  deleteAllPartBeforeEvent: 'Creating the event will delete all participants. Event participants must be added through event session(s). Are you sure you wish to proceed?',
  cantAccessPartOnEventReason: 'This training has an associated event. Event participants must be added through event session(s).',
  cantAccessPart: 'Can not add participants',
  errorSaving: 'There was an error while saving.',
  enterTitle: 'Enter event title to continue with save.',
  enterDescription: 'Enter Description to continue with save.',
  enterAtLeastOneOrganizer: 'Enter at least one organizer to continue with save.',
  cancelRegistretion: 'Cancel Registration',
  session: 'Session',
  register: 'Register',
  registrationError: 'There was an error when trying to register you to this event.',
  registrationSuccess: 'Your registration was succesfull.',
  cancelRegistrationError: 'There was an error when trying to cancel your registration to this event.',
  cancelRegistrationSuccess: 'The cancelation of your registration was succesfull.',
  noEvents: 'No available events.',
  noRegistrations: 'You are not registered to any events.',

  // EMPLOYEE ADDITIONAL INFO Tab
  spouseInfo: 'Spouse Information',
  spouseWorkingForDeloitte: 'Spouse Working for Deloitte',
  spouseName: 'Spouse Name',
  spouseEmplID: 'Spouse Employee ID',
  spouseCompany: 'Spouse Company',
  spouseServLine: 'Spouse Service Line',
  spouseDept: 'Spouse Department',
  spouseBranch: 'Spouse Branch',
  spouseLocation: 'Spouse Location',
  //Secondary Info
  secondaryInfo: 'Secondary Info',
  secondaryCompany: 'Secondary Company',
  secondaryLocation: 'Secondary Location',

  // Medical Scheme
  insuredPerson: 'Insured Person',
  insuranceCo: 'Insurance Company',
  contributionOfEmployer: 'Contribution (EUR) of Employer',
  contributionOfEmployee: 'Contribution (EUR) of Employee',
  medicalSchemeTitle: 'Medical Scheme Details',

  // Provident Fund
  emplContribution: 'Contribution (%) of Employee',
  employerContribution: 'Contribution (%) of Employer',
  provFundTitle: 'Provident Fund Details',
  emplContrReqMess: 'Employee Contribution is required!',
  employerContrReqMess: 'Employer Contribution is required!',
  provFundReqMess: 'Provident Fund is required!',
  endDateBeforeStartDate: 'End Date must be later than the Start Date!',

  // Promotion History
  dateOfPromotion: 'Date of Promotion',
  reviewer: 'Reviewer',
  promHistTitle: 'Promotion History Details',
  dateOfPromotionReqMess: 'Date of Promotion is requred!',

  // Generic 
  loading: 'Loading please wait...',
  saving: 'Saving...',
  state: 'State',
  number: 'Number',

  // Locations
  telNumber: 'Telephone Number',
  faxNumber: 'Fax Number',
  officeAddress: 'Office Address',
  city: 'City',
  postCode: 'Post Code',
  province: 'Province',
  country: 'Country',
  regionalCode: 'Regional Code',
  locationsLoadingPreview: 'No Data Available\nIt looks like there are no locations added yet. Please add new locations to see them here.',
  locations: 'Locations',
  additionalInfo: 'Comments',
  additionalInfos: 'Additional Information',

  // Bad Request Messages
  multEmptyLines: 'Multiple empty lines are not allowed. Please add the appropriate information to the existing empty line and try again. ',
  issueMessage: 'There was an issue with the updates, please try again later.',
  issueDeleteMessage: 'There was an issue with the deletions, please try again later.',
  duplicateBranchesMessage: 'It looks like you have entered the same Branch code in multiple rows. Please ensure that each row has a unique code to avoid any conflicts.',
  branchWithLocationDeleteMess: 'Branches with Locations cannot be Deleted. Please delete the Locations first.',
  mandatoryCodeNotGivenBranches: 'It looks like you have not provided the Mandatory Branch code. Please provide it to be able to proceed with saving your changes.',
  mandatoryCodeNotGivenLocations: 'It looks like you have not provided the Mandatory Location code. Please provide it to be able to proceed with saving your changes.',
  wrongDatesBranches: 'Please make sure that the dates are consecutive',
  descEmpty: 'Description cannot be empty ',
  activeScheme: 'There is no active Salary Scheme please remove To Date from the active Scheme ',
  onePrimary: 'Multiple open ended salary scheme located. Only the currently active scheme must open ended',
  multiplePrimariesEmplDepts: 'You must set exactly ONE department as primary!',
  sSchemeEmpty: 'Salary Scheme date cannot be empty',
  duplicates: 'Duplicate Values are not allowed. Please correct the highlighted values',
  noChanges: 'Save aborted, no changes to save.',
  leaveCodeandDesc: 'Save aborted, all Leave Codes and Leave Descriptions must be unique',
  deleteFailed: 'Failed to delete, please try again.',
  cannotDeleteAllEntries: 'Cannot delete all rows, need at least one.',
  issueReload: 'Failed to reload data.',
  enterDate: 'All rows should have a date.',
  mandatoryCodeNotGivenCategory: 'It looks like you have not provided the Mandatory Category code. Please provide it to be able to proceed with saving your changes.',
  loadTrainingsError: 'There was an error on loading data.',

  // Success Messages
  insertLocationSuccMess: 'Your new location has been successfully added to the system!',
  updateLocationSuccMess: 'The location details have been successfully updated!',
  deleteLocationSuccMess: 'The location has been successfully deleted from the system.',
  allOperationsSuccMess: 'All operations were successful!',
  saveSuccess: 'Data has been saved successfully',
  submittedSuccess: 'Data has been submitted successfully',
  confirmMessage: 'Confirm',
  validationSuccess: 'Validation Success',
  // Locations
  telNumber: 'Telephone Number',
  faxNumber: 'Fax Number',
  officeAddress: 'Office Address',
  city: 'City',
  postCode: 'Post Code',
  province: 'Province',
  country: 'Country',
  regionalCode: 'Regional Code',

  // Functions
  function: 'Function',
  headOfFunction: 'Head of Function',
  exceedInvAmount: 'Exceed Inv. Amount',
  d365Code: 'D365 Code',
  createNewFunction: 'New',
  deleteFunction: 'Delete',
  saveFunction: 'Save',
  changeFunctionMessage: 'You have unsaved changes.\n If you switch Functions now, your changes will be lost.\n Please save your changes before proceeding.',
  functionsNoDataPreview: 'No Data Available\nIt looks like there are no Functions added yet. Please add new functions to see them here.',
  functions: 'Functions',
  functionCode: 'Interface',
  functionDescription: 'Interface Description',
  chargesCode: 'Admin Charges Service Code',

  //WORKFLOWS
  saveSuccessMessage: 'Workflow has been saved successfully',
  deleteSuccessMessage: 'Workflows successfully deleted',
  errorMessage: 'Error saving employee Workflows',
  delete: 'Delete',
  noWorkflowSelected: 'No Workflow Selected',

  //COMPANY WORKFLOWS
  addNewWorkflow: 'Add New Workflow:',
  flexibleApproverMessage: 'Flexible Approver Message:',
  noApprover: 'No Approver:',
  description: 'Description',
  category: 'Category:',
  selectWorkflow: 'Select A Workflow',
  Edit: "Edit",
  Steps: "Steps",
  Criteria: "Criteria",
  CopyWorkflowSteps: "Copy Workflow Steps",
  pleaseSelectWorkflow: 'Please Select Workflow',
  workflowSavedSuccessfully: 'Workflow Saved Successfully',
  errorSavingWorkflow: 'Error Saving Workflow',
  stepsNotAvailableNoApprover: 'No Approver Must Be Disabled to Access Steps',
  errorDeleteStepsFirst: 'Delete Steps First',
  areYouSureDeleteWorkflow: 'Are You Sure You Want To Delete Workflow?',
  workflowDeletedSuccessfully: 'Workflow Deleted Successfully',
  errorDeletingWorkflow: 'Error Deleting Workflow',
  pleaseSelectStepToSave: "Please Select New Step To Save",
  errorAssignedEmployees: "Error, There are Assigned Employees to this Workflow",

  //COMPANY WORKFLOW MODAL
  pleaseEnterDescription: 'Please Enter Description',
  pleaseSelectCategory: 'Please Select Category',
  noChangesMade: "No Changes Were Made",


  //COMPANY WORKFLOW STEPS
  operators: "Operators",
  approvalcriteria: "Approval Criteria",
  specificapprovers: "Specific Approvers",
  approverlist: "Approver List",
  step: 'Step',
  noofApprovals: 'No. of Approvals',
  deleteStep: "Delete Step",
  areYouSureDeleteStep: "Are You Sure You Want To Delete Step?",
  deleteAllSteps: "Delete All Steps",
  areYouSureDeleteAllSteps: "Are You Sure Delete All Steps?",
  newStep: "New Step",
  Criteriaexpressionhassyntaxerror: "Criteria expression has syntax error",
  workflowStepSavedSuccessfully: "Workflow Step Saved Successfully",
  failedToSaveWorkflowStep: "Failed To Save Workflow Step",
  workflowStepDeletedSuccessfully: "Workflow Step Deleted Successfully",
  failedToDeleteWorkflowStep: "Failed To Delete Workflow Step",
  allWorkflowStepsDeletedSuccessfully: "All Workflow Steps Deleted Successfully",
  confirm: "Confirm",
  cancel: "Cancel",
  noOfApprovalsRequired: "Number Of Approvals Is Required",

  //COMPANY WORKFLOW CRITERIA
  categorycriteria: "Category Criteria",
  categorycriteriaparam: "Category Criteria Parameters",
  worfkflowcreteria: "Workflow Criteria",
  pleaseSelectCriteria: "Please Select Criteria",
  enterCustomValue: "Add Criteria Parameters",
  pleaseSelectParameter: "Please Select Parameter",
  invalidParameterExpression: "Invalid Parameter Expression",
  parameterAlreadyAdded: "Parameter Already Added",
  Criteriasavedsuccessfully: "Criteria Saved Successfully",
  Failedtosavecriteria: "Failed to Save criteria",
  syntaxError: "Syntax Error, Please Choose <=X, >X, =X, >=X or between X and Y",

  //COMPANY COPY WORKFLOW STEPS
  pleaseSelectSourceWorkflow: "Please Select Workflow to Copy Steps From",
  cannotCopyToSameWorkflow: "Cannot Copy To the Same Workflow",
  copyWorkflowSteps: "Copy Workflow Steps",
  selectSourceWorkflow: "Select Workflow to Copy From",
  workflowStepsCopiedSuccessfully: "Workflow Steps Copied Successfully",
  areYouSureCopyWorkflowSteps: "Are you sure you want to copy workflow's \"{{sourceWorkflow}}\" steps to workflow \"{{targetWorkflow}}\"? If any steps exist in workflow \"{{targetWorkflow}}\", they will be replaced.",
  confirm: "Confirm",
  cancel: "Cancel",

  // Academic Qualifications 
  dos: 'Date Started',
  doa: 'Date Awarded',
  institution: 'Institution',
  institutionEmpty: 'Please select Institution for all Academic Qualifications.',
  titleAwareded: 'Title Awarded',
  titleAwarededEmpty: 'Please select Title Awarded for all Academic Qualifications.',
  fos: 'Field of Studies',
  res: 'Result',
  resEmpty: 'Please select Results for all Academic Qualifications.',
  grade: 'Grade',
  nooy: 'No. of years',
  type: 'Type',
  status: 'Status',
  statusEmpty: 'Please select Status for all Academic Qualifications.',
  Comments: 'Comments',
  errorSave: 'Failed to save. Please check your values and try again. If the error persists please contact your administrator.',
  academicQualSuccessSave: 'Save successful',
  AcadNoReviewDataPreview: "No Data Available\nIt looks like there are no Academic Qualifications added yet. Please add new Qualification to see them here.",
  errorReject: 'Failed to reject. There was an error with rejecting the timesheet. Try again later',

  //AdditionalQualifications
  qualification: 'Qualification',
  level: 'Level',
  subEmpty: 'Subject is required for all Additional Qualifications.',
  QualEmpty: 'Please enter the Qualification for all Aditional Qualifications.',
  statEmpty: 'Please select Status for all Additional Qualifications.',
  doc: 'Document',

  //Special Documents 
  docType: 'Document Type',
  name: 'Name',
  number: 'Document Number',
  issueDate: 'Issue Date',
  expiryDate: 'Expiry Date',
  isRenewed: 'Is Renewed',
  notifyMe: 'Notify Me',
  docStatus: 'Document Status',
  issuedBy: 'Issued By',
  relType: 'Relation Type',
  profession: 'Employee Profession',
  professionOthLang: 'Profession (Other language)',
  comments: 'Comments',
  Doc: 'Document',
  docStatusEmpty: 'Please select Status for all Special Documents.',
  issuedByEmpty: 'Please enter Issued By for all Special Documents.',
  changesCancelled: 'Changes have been cancelled.',
  changesSavedSuccessfully: 'Changes have been saved successfully.',
  noSpecialDocsDataPreview: "No Data Available\nIt looks like there are no Special Documents added yet. Please add Special Documents to see them here.",
  noAttachment: "No Attachment",

  //Exit Process
  exitProcess: 'Exit Process',
  reason: 'Reason For Leaving',
  newEmpl: 'New Employment',
  interviewer: 'Interviewer',
  resignationDate: 'Resignation Date',
  voluntary: 'Voluntary',
  exitdate: 'Date',
  noExitProcessDataPreview: "No Data Available\nIt looks like no Exit Processes have occured yet.",
  reasonEmpty: 'Please enter Reason for Leaving.',
  interviewerEmpty: 'Please enter Interviewer.',
  dateEmpty: 'Please select both exit and resignation Date.',


  // Service Lines
  hos: 'Head of Service Line',
  servCode: 'Service Code',
  changeServiceLineMessage: 'You have unsaved changes.\n If you switch Service Lines now, your changes will be lost.\n Please save your changes before proceeding.',
  servLinesNoDataPreview: 'No Data Available\nIt looks like there are no Service Lines added yet. Please add new service lines to see them here.',
  serviceLines: 'Service Lines',

  //Departments
  hod: 'Head of Department',
  deptCalendarFilter: 'Filter Calendar By Department',
  interface: 'Interface',
  interfaceDesc: 'Interface Description',
  adminChargesServices: 'Admin Charges Services',
  d365FDCode: 'D365 FD Code',
  deptsNoDataPreview: 'No Data Available\nIt looks like there are no Departments added yet. Please add new departments to see them here.',
  departments: 'Departments',

  // L4
  L4: 'L4',

  from: 'From',
  to: 'To',
  day: 'Day',

  // Bad Request Messages
  multEmptyLines: 'Multiple empty lines are not allowed. Please add the appropriate information to the existing empty line and try again. ',
  issueMessage: 'There was an issue with the updates, please try again later.',
  duplicateBranchesMessage: 'It looks like you have entered the same Branch code in multiple rows. Please ensure that each row has a unique code to avoid any conflicts.',
  branchWithLocationDeleteMess: 'Branches with Locations cannot be Deleted. Please delete the Locations first.',
  duplicateDepartmentsMessage: 'It looks like you have entered the same Department code in multiple rows. Please ensure that each row has a unique code to avoid any conflicts.',
  duplicateServiceLinesMessage: 'It looks like you have entered the same Service code in multiple rows. Please ensure that each row has a unique code to avoid any conflicts.',
  duplicateFunctionsMessage: 'It looks like you have entered the same Function code in multiple rows. Please ensure that each row has a unique code to avoid any conflicts.',
  functionWithServLinesDeleteMess: 'Functions with Service Lines cannot be Deleted. Please delete the Service Lines first.',
  servLinesWithDeptsDeleteMess: 'Service Lines with Departments cannot be Deleted. Please delete the Departments Lines first.',
  primaryKeyViolation: 'More than one records exist with the same key. Note that records must be unique. Your changes will not be saved!',
  mandatoryCodeNotGivenFunctions: 'It looks like you have not provided the Mandatory Function code. Please provide it to be able to proceed with saving your changes.',
  mandatoryCodeNotGivenServLines: 'It looks like you have not provided the Mandatory Service Line code. Please provide it to be able to proceed with saving your changes.',
  mandatoryCodeNotGivenDepartments: 'It looks like you have not provided the Mandatory Department code. Please provide it to be able to proceed with saving your changes.',
  deptsIsUsedByEMPLDEPTS: 'Some of the departments you are trying to delete are currently assigned to employees and cannot be deleted.',

  // Success Messages
  insertLocationSuccMess: 'Your new location has been successfully added to the system!',
  updateLocationSuccMess: 'The location details have been successfully updated!',
  deleteLocationSuccMess: 'The location has been successfully deleted from the system.',
  allOperationsSuccMess: 'All operations were successful!',
  confirmMessage: 'Confirm',

  // Employee Wizard
  emplWizard: 'Employee Wizard',

  // Months
  jan: "January",
  feb: "February",
  mar: "March",
  apr: "April",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "August",
  sep: "September",
  oct: "October",
  nov: "November",
  dec: "December",


  // Short Months 
  m5: "Jan",
  m6: "Feb",
  m7: "Mar",
  m8: "Apr",
  m9: "May",
  m10: "Jun",
  m11: "Jul",
  m12: "Aug",
  m1: "Sep",
  m2: "Oct",
  m3: "Nov",
  m4: "Dec",

  // General
  asterisk: "*",

  //User Roles
  userRole: 'User Role',
  encyptedPassword: 'Encrypted Password',
  reqRestPassOnLogin: 'Require reset password on next login',
  lock: 'Lock',
  loadingUserRoles: 'Loading User Roles...',
  emplUserRoleSavedSuccMess: 'User Role saved successfully!',
  emplUserRoleErr: 'An error occurred while saving the updates. Please try again later.',
  issuePassword: 'Issue Password',
  issuedPassSucc: 'Password Issued Successfully!',
  issuedPassErr: 'The password has failed to be issued. Please try again and if the problem persists please contact your system administrator.',
  sendUsername: 'Send Username',
  emailSendShortly: 'The email will be forwarded shortly.',
  noEmailMessNotSendUsername: 'The employee does not have an email yet. Please re-send the username once the employee\'s email is completed.',
  noEmailMessNotSendPassword: 'The employee does not have an email yet. Please re-send the password once the employee\'s email is completed.',
  emailNotSendErr: 'The email has failed to be sent. Please try again and if the problem persists please contact your system administrator.',
  errorUpdating: 'There was an error while updating the database. Please contact your system administrator.',

  // Employee Authorizations
  addRule: 'Add Rule',
  includeInactive: 'Include Inactive Employees',
  includedEmpls: 'Included Employees',
  includeSpecEmpls: 'Include Specific Employees',
  summary: 'Summary',
  emplsSelectedThroughCriteria: 'Employees Selected Through Criteria',
  employeesExcluded: 'Exclude Specific Employees',
  specificEmplsAdded: 'Specific Employees Added',
  totalNumOfEmplsIncluded: 'Total Number of Employees Included',
  addSpecificEmpls: 'Add Specific Employees',
  activeStatus: 'Active Status',
  missingFields: 'Missing Fields...',
  missingFieldsSubMessage: 'To select specific employees, please ensure the company field is completed.',
  addChosenEmpls: 'Add Chosen Employees',
  emplsSucc: 'Employees Successfully Added',
  onAddSpecificCancelTitle: 'Are you sure?',
  onAddSpecificCancelMessage: 'If you proceed, all currently selected employees will be removed from your list.',
  emplAuthSuccMess: 'Employee\'s authorizations where added successfully!',

  //Reports To 
  manager: 'Manager',
  notifiedUponApproval: 'Notified Upon Approval',
  primary: 'Primary',
  approvesLeaves: 'Approves Leaves',
  approvesTimesheets: 'Approves Timesheets',
  noDataAvailable: 'No Data Available',
  notValidReportsTo: 'Please select only one reports to for primary, one for approving leaves and one for approving timesheets.',
  reportsToSuccMess: 'Reports To was updated successfully!',
  loadManagersFailed: 'Loading managers dropdown failed',

  //Workflows
  workflow: 'Workflow',
  workflowCategory: 'Workflow Category',

  // Leave Analysis
  leaveAnalysis: 'Leave Analysis',
  createLeaveAnalysisMess: 'Do you want to create the employee\'s leave analysis?',
  successLeaveaAnalysis: " Leavea Analysis created successfully for the next fiscal year.",
  missingUser: "Missing user, employee, or company information.",
  anErrorOccurred: "An error occurred while creating leave analysis.",
  failedTo: "Cannot create leave analysis for the next fiscal year.",
  createLA: 'Create Leave Analysis',
  enterYear: 'Enter the fiscal year you want to create',

  // Advanced Settings 
  changeEmplId: 'Change Employee ID',
  advSettings: 'Advanced Settings',
  emplIdSameErr: 'New EmployeeId cannot be the same the existing EmployeeId',
  emplIdSucc: 'EmployeeId changed succesfuly',
  emplIdExists: 'New EmployeeId already exists. Please select a different one',

  // Alerts
  emplAlerts: 'Employee Alerts',
  standardAlerts: 'Standard alerts',
  customAlerts: 'Custom alerts',
  completeExistingAlerts: "Complete existing alert",
  selectMonitorFirst: "Please select a monitor before adding a new alert",
  saveSuccess: 'Changes saved successfully',
  saveError: 'Failed to save changes. Please try again.',
  noChanges: 'No changes to save',
  saving: 'Saving...',

  // Shifts 
  basicDetails: 'Basic Details',
  createTemplate: 'New shift template',
  editTemplate: 'Edit shift template',
  deleteTemplate: 'Delete shift template',
  templateDetails: 'Template details',
  breakWindows: 'Break windows',
  livePreview: 'Live preview',
  saveSuccess: 'Template saved',
  deleteConfirm: 'Delete template?',
  deleteSchedulePeriodConfirmation: 'Are you sure you want to delete this schedule period? If yes, also clieck the save button to confirm.',
  deleteShiftAssignmentConfirmation: 'Are you sure you want to delete this shift assignment?',
  unsavedRosterChangesTitle: 'Unsaved changes',
  unsavedRosterChangesMessage: 'You have unsaved roster changes. If you continue without saving, your progress will be lost. Are you sure?',
  discardChanges: 'Discard changes',
  tempName: 'Template Name',
  shiftType: 'Shift type',
  startTime: 'Start time',
  endTime: 'End time',
  duration: 'Duration',
  colorCode: 'Color',
  isOvernight: 'Overnight Shift',
  isActive: 'Active',
  breakStart: 'Break start',
  breakEnd: 'Break end',
  breakDuration: 'Break duration (min)',
  isPaid: 'Paid break',
  tempNameReq: '*Template name is required',
  shiftTypeReq: '*Shift type is required',
  startTimeReq: '*Start time is required',
  endTimeReq: '*End time is required',
  durationMinutesReq: '*Duration is required',
  colorCodeReq: '*Please select a color',
  isOvernightReq: '*Please specify if this is an overnight shift',
  isActiveReq: '*Please specify if this template is active',
  breakStartReq: '*Break start time is required',
  breakEndReq: '*Break end time is required',
  breakDurationMinutesReq: '*Break duration is required',
  isPaidReq: '*Please specify if this break is paid',
  emplIdExists: 'New EmployeeId already exists. Please select a different one',
  overnight: 'Overnight',
  sameDay: 'Same day',
  noBreaks: 'No Breaks',
  endTimeAfterStart: "End time must be after start time",
  breakStartBeforeEnd: "Break start time must be before break end time",
  breakEndAfterStart: "Break end time must be after break start time",
  breakWithinShift: "Break time must be within the shift time",

  // Company Authorizations
  removeAll: "Remove All",
  authorisedUsers: "Authorised Users",
  noAuthorisedUsers: "No Authorised Users",
  availableUsers: "Available Users",
  noAvailableUsers: "No Available Users",
  authSuccessSave: "Authorizations Successfully Saved",
  failedSave: "Failed to save authorizations",

  versionMismatchTitle: "Version Mismatch",
  versionMismatch: "You are running an outdated version. Please contact your administrator.",
  versionCheckFailedTitle: "Version Check Failed",
  versionCheckFailed: "We couldn't verify your app version. Please try again later.",
  //Professional Bodies
  pro: "Professional Body",
  memtype: "Memebership Type",
  memdate: "Memebership/Registration Date",
  examdate: "Date of Final Successfull Exam",
  reginumber: "Memebership/Registration Number",
  expdate: "Memebership Expiration Date",
  profBodiesSuccessSave: "Professional Bodies Successfully Saved",
  proEmpty: "Professional Body Cannot be Empty",
  memtypeEmpty: "Memebership Type Cannot be Empty"
};
